module.exports = __webpack_public_path__ + "img/کارت-ویزیت-سلفون-مخملی-برجسته.48c46a61.png";